import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findExitRule= (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-cluster/v1/exitRule/findAll?`+params,
        method: 'GET'
    })
}

export const addExitRule = (data) => {
    return request({
        url: `${baseUrl}/joins-cluster/v1/exitRule/insertExitRule`,
        method: 'POST',
        data: data
    })
}
export const editExitRule = (data) => {
    return request({
        url: `${baseUrl}/joins-cluster/v1/exitRule/updateExitRule`,
        method: 'PUT',
        data: data
    })
}
export const delExitRule = (ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-cluster/v1/exitRule/deleteExitRule/${temp}`,
        method: 'DELETE'
    })
}
export const stopExitRule= (id) => {
    return request({
        url: `${baseUrl}/joins-cluster/v1/exitRule/stopExitRule/${id}`,
        method: 'GET'
    })
}
export const startExitRule= (id) => {
    return request({
        url: `${baseUrl}/joins-cluster/v1/exitRule/startExitRule/${id}`,
        method: 'GET'
    })
}